import AppDispatcher from '../dispatcher/AppDispatcher';
import AuthConstants from '../constants/AuthConstants';
import { EventEmitter } from 'events';

const CHANGE_EVENT = 'change'

function setUser(session) {
  if (!localStorage.getItem('odoo_user_id')) {
    localStorage.setItem('odoo_user_id', session.user_id)
    localStorage.setItem('odoo_user_name', session.user_name)
    localStorage.setItem('odoo_user_login', session.login)
    localStorage.setItem('odoo_user_password', session.password)
    localStorage.setItem('odoo_user_pack_password', session.pack_password)
    localStorage.setItem('odoo_pakowalnia_id', session.pakowalnia_id)
    localStorage.setItem('odoo_pakowalnia_name', session.pakowalnia_name)
    localStorage.setItem('odoo_config', JSON.stringify(session.config))
  }
}

function removeUser() {
  localStorage.removeItem('odoo_user_id')
  localStorage.removeItem('odoo_user_name')
  localStorage.removeItem('odoo_user_login')
  localStorage.removeItem('odoo_user_password')
  localStorage.removeItem('odoo_user_pack_password')
  localStorage.removeItem('odoo_pakowalnia_id')
  localStorage.removeItem('odoo_pakowalnia_name')
  localStorage.removeItem('odoo_config')
  localStorage.removeItem('odoo_conf_url')
  localStorage.removeItem('odoo_conf_port')
}

class AuthStoreClass extends EventEmitter {
  _invalid: false

  emitChange() {
    this.emit(CHANGE_EVENT)
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback)
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback)
  }

  isAuthenticated() {
    if (localStorage.getItem('odoo_user_id')) {
      return true
    }
    return false
  }

  getUser() {
    return {
      'id': parseInt(localStorage.getItem('odoo_user_id')),
      'name': localStorage.getItem('odoo_user_name'),
      'login': localStorage.getItem('odoo_user_login'),
      'password': localStorage.getItem('odoo_user_password'),
      'pack_password': localStorage.getItem('odoo_user_pack_password')
    }
  }
  getConfig(){
    return JSON.parse(localStorage.getItem('odoo_config'))
  }
  getPakowalnia(){
    return parseInt(localStorage.getItem('odoo_pakowalnia_id'))
  }
  getPakowalniaName(){
    return localStorage.getItem('odoo_pakowalnia_name')
  }
}

const AuthStore = new AuthStoreClass()

// Here we register a callback for the dispatcher
// and look for our various action types so we can
// respond appropriately
AuthStore.dispatchToken = AppDispatcher.register(action => {

  switch(action.actionType) {

    case AuthConstants.LOGIN_USER:
      if(typeof window.dozwolone_pakowalnie == 'undefined' || (window.dozwolone_pakowalnie.indexOf(action.session.pakowalnia_id) >= 0)){
        AuthStore._invalid = false
        setUser(action.session)
      } else {
        AuthStore._invalid = true
      }
      AuthStore.emitChange()
      break

    case AuthConstants.LOGOUT_USER:
      removeUser();
      AuthStore.emitChange()
      break

    case AuthConstants.LOGIN_USER_ERROR:
      AuthStore._invalid = true
      AuthStore.emitChange()

    default:
  }

})

export default AuthStore



// WEBPACK FOOTER //
// ./src/stores/AuthStore.js